import ValidatePhoneNumber from '@features/games/profile/validate-phone/validate-phone';
export default ValidatePhoneNumber;
